export default __webpack_public_path__ + "img/elemets-yellow-left.png?d3d0";